import React from 'react'
import { FarmDto } from 'src/dto/farm.dto'
import { cnpjMask } from 'src/utils'
import { ActionsPopover } from '../components/ActionsPopover'

interface UsePropertiesTableHeaderProps {
  handleItemDetailModal: (item: FarmDto | undefined | null) => void
  handleSelectFarm: (item: FarmDto) => void
}

export const usePropertiesTableHeader = ({
  handleItemDetailModal,
  handleSelectFarm
}: UsePropertiesTableHeaderProps) => {
  const tableHeader = [
    {
      property: 'descricao',
      name: 'NOME',
      textAlign: 'center'
    },
    {
      property: 'razao',
      name: 'RAZAO SOCIAL',
      textAlign: 'center',
      format: (value: string | null) => value || '-'
    },
    {
      property: 'documento',
      name: 'CNPJ',
      textAlign: 'center',
      format: (value: string | null) => (value ? cnpjMask(value) : '-')
    },
    {
      property: 'proprietario',
      name: 'PROPRIETARIO',
      textAlign: 'center',
      format: (value: string | null) => value || '-'
    },
    {
      property: 'cidade',
      name: 'CIDADE',
      textAlign: 'center',
      format: (value: string | null) => value || '-'
    },
    {
      property: 'estado',
      name: 'UF',
      textAlign: 'center',
      format: (value: string | null) => value || '-'
    },
    {
      size: 122,
      property: 'actions',
      compoment: (value: FarmDto) => (
        <ActionsPopover
          onEdit={() => handleItemDetailModal(value)}
          onSelectFarm={() => handleSelectFarm(value)}
        />
      )
    }
  ]

  return { tableHeader }
}
